import React, { FC, SVGProps } from 'react'

export const IconExport: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="#9595A3"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33301 1.5C9.60915 1.5 9.83301 1.72386 9.83301 2V4.66667C9.83301 4.71087 9.85057 4.75326 9.88182 4.78452C9.91308 4.81577 9.95547 4.83333 9.99967 4.83333H12.6663C12.9425 4.83333 13.1663 5.05719 13.1663 5.33333C13.1663 5.60948 12.9425 5.83333 12.6663 5.83333H9.99967C9.69025 5.83333 9.39351 5.71042 9.17472 5.49162C8.95592 5.27283 8.83301 4.97609 8.83301 4.66667V2C8.83301 1.72386 9.05687 1.5 9.33301 1.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66634 2.5C4.44533 2.5 4.23337 2.5878 4.07709 2.74408C3.92081 2.90036 3.83301 3.11232 3.83301 3.33333V12.6667C3.83301 12.8877 3.9208 13.0996 4.07709 13.2559C4.23337 13.4122 4.44533 13.5 4.66634 13.5H7.66634C7.94248 13.5 8.16634 13.7239 8.16634 14C8.16634 14.2761 7.94248 14.5 7.66634 14.5H4.66634C4.18011 14.5 3.7138 14.3068 3.36998 13.963C3.02616 13.6192 2.83301 13.1529 2.83301 12.6667V3.33333C2.83301 2.8471 3.02616 2.38079 3.36998 2.03697C3.7138 1.69315 4.18011 1.5 4.66634 1.5H9.33301C9.46562 1.5 9.59279 1.55268 9.68656 1.64645L13.0199 4.97978C13.1137 5.07355 13.1663 5.20073 13.1663 5.33333V8.66667C13.1663 8.94281 12.9425 9.16667 12.6663 9.16667C12.3902 9.16667 12.1663 8.94281 12.1663 8.66667V5.54044L9.1259 2.5H4.66634ZM11.6461 10.3131C11.8414 10.1179 12.158 10.1179 12.3532 10.3131L14.3532 12.3131C14.5485 12.5084 14.5485 12.825 14.3532 13.0202L12.3532 15.0202C12.158 15.2155 11.8414 15.2155 11.6461 15.0202C11.4509 14.825 11.4509 14.5084 11.6461 14.3131L12.7926 13.1667H9.33301C9.05687 13.1667 8.83301 12.9428 8.83301 12.6667C8.83301 12.3905 9.05687 12.1667 9.33301 12.1667H12.7926L11.6461 11.0202C11.4509 10.825 11.4509 10.5084 11.6461 10.3131Z"
    />
  </svg>
)
